// import React from 'react'; // , useContext
import { Link } from 'react-router-dom';
// import DisplayNewsletterForm from '../../components/DisplayNewsletterForm';

const Did = () => {

 
  return (
    <div id="courses">
      <div id="title">
        <h1>Admin pour Didier</h1>
      </div>
      <div id="content">
        <Link className="button" to="/admin-cours">Gérer les cours</Link>
        <Link className="button" to="/admin-team">Gérer l'équipe</Link>
        <Link className="button" to="/admin-photos">Gérer les photos</Link>
        {/* <Link className="button" to="/admin-stages">Gérer les stages</Link> */}
        <Link className="button" to="/admin-inscriptions">Gérer les inscriptions</Link>  
          {/* <DisplayNewsletterForm /> */}
      </div>
    </div>
  )
};

export default Did;
